// "Is a video playing right now" as one module-level fact (spec §5.4).
// Watching a flight is activity, so the heartbeat has to know about it, and the
// viewer that knows sits several components away from the hook that beats.
import { useSyncExternalStore } from "react";

let playing = false;
const listeners = new Set<() => void>();

export function setPlaying(next: boolean): void {
  if (playing === next) return;
  playing = next;
  for (const l of listeners) l();
}

/** Read outside React — the heartbeat calls this from a timer. */
export function isPlaying(): boolean {
  return playing;
}

export function usePlaying(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
    () => playing,
    () => playing,
  );
}
